var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAesthetic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.805,
    height: 13.716,
    viewBox: "0 0 19.805 13.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-beauty-salon",
    "data-name": "Icon map-beauty-salon",
    d: "M16.121,3.057H13.253a.385.385,0,0,0,0,.77h2.868v.395H13.253a.385.385,0,0,0,0,.77h2.868v.4H13.253a.385.385,0,0,0,0,.77h2.868v.385H13.253a.39.39,0,0,0,0,.779h2.868v.385H13.253a.385.385,0,0,0,0,.77h2.868v.385H13.253a.385.385,0,0,0,0,.77h2.868v.394H13.253a.385.385,0,0,0,0,.77h2.868v.384H13.253a.385.385,0,0,0,0,.77h2.868v7.493a.871.871,0,0,0,1.741,0V1.912A1.2,1.2,0,0,0,16.724.729H13.253a.385.385,0,0,0,0,.77l2.868.009v.384H13.253a.385.385,0,0,0,0,.77h2.868ZM13.056,16.341A2.025,2.025,0,0,0,10.022,14.5v-5.1L8.955,1A.314.314,0,0,0,8.618.72C8.487.724,8.225.776,8.2,1L7.134,9.405v5.1A1.992,1.992,0,0,0,4.146,16.33a2.093,2.093,0,0,0,2.117,2.125A2.153,2.153,0,0,0,8.372,16.33v-5.3h.413v5.3a2.084,2.084,0,0,0,1.927,2.106A2.933,2.933,0,0,0,11.3,20.37a.493.493,0,0,0,.792-.567,1.823,1.823,0,0,1-.26-1.57A2.074,2.074,0,0,0,13.056,16.341ZM6.311,17.389a1.049,1.049,0,1,1,1.042-1.048,1.049,1.049,0,0,1-1.042,1.048Zm3.536-1.048a1.042,1.042,0,1,1,1.042,1.048A1.053,1.053,0,0,1,9.847,16.341Z",
    transform: "translate(20.525 -4.146) rotate(90)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAesthetic);
export default __webpack_public_path__ + "static/media/aesthetic.cac739512a7c10a6c11e0cb6121f76cb.svg";
export { ForwardRef as ReactComponent };